import React from 'react'
import { Container } from 'react-bootstrap'
import Logo from '../images/logo2.webp'
import { Link } from 'react-router-dom'


const Footer = () => {


  return (
    <>
      <footer className='footer_section'>
        <Container>
          <div className='footer_content'>
            <div className='footer_section_logo'>
              <img src={Logo} alt='logo' />
            </div>
            <div className="footer_pages">
              <ul>
                <li><Link to="privacy-policy">Privacy Policy</Link></li>
                <li><Link to="terms-service">Terms of Service</Link></li>
              </ul>
            </div>
            <p>Copyright © 2025 alleventsinsure. All rights reserved</p>
          </div >
        </Container >
      </footer>
    </>

  )
}

export default Footer